import { omitBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { EventParticipantStatus } from '@/modules/events/constants';

import { EventOrderStatus } from '../types';

export type EventFiltersType = Partial<{
  search: string;
  status: EventOrderStatus | EventParticipantStatus;
  statuses: EventOrderStatus[];
  date: string;
  type: string;
}>;

export enum ChangeTypes {
  Debounce = 'debounce',
}

export type FiltersChangeType = (
  inputs: EventFiltersType,
  type?: ChangeTypes.Debounce
) => void;

export const useEventFilters = () => {
  const [filters, setFilters] = useState<EventFiltersType>({});

  const [searchValue, setSearchValue] = useState(filters.search);
  const [debouncedSearchValue] = useDebounce(searchValue, 300);

  useEffect(() => {
    filtersChange({ search: debouncedSearchValue || '' });
  }, [debouncedSearchValue]);

  const filtersChange: FiltersChangeType = (inputs, type) => {
    if (type === ChangeTypes.Debounce) {
      setSearchValue(inputs.search);
      return;
    }

    setFilters(omitBy({ ...filters, ...inputs }, (value) => value === ''));
  };

  return {
    filters,
    filtersChange,
  };
};
